export const AUTOFILL_FIELDS: string[] = [
  'contactDate',
  'site',
  'contactWeek',
  'auditWeek',
  'flaggedForAbuse',
  'contactType',
  'handledDate',
  'sic1',
  'sic2',
  'sic3',
  'sic4',
  'sic1_2',
  'rsprUtilization',
  'rsprPolicyRecommendation',
];
